import { del, get, post } from "utils/Service";

const ENDPOINT = "/api/extracts";
const CONTENT_SUFFIX = "content";
const USERS_SUFFIX = "users";

// TODO: user rights.
export enum ExtractStatus {
	ACTIVE = "ACTIVE",
	ARCHIVED = "ARCHIVED"
}

export type ExtractInfo = {
	id: number;
	name: string;
	created: string;
	trajectoryId: number;
	trajectoryName: string;
	status: ExtractStatus;
};

export type ExtractAccess = {
	user: string;
};

export type GenerateExtractRequest = {
	name: string;
	extract: number;
	trajectories: number[];
	// The day (yyyy-MM-dd) whose state the PDF renders; omitted for the
	// current state.
	asOf?: string;
};

export function getExtracts(): Promise<ExtractInfo[]> {
	return get(ENDPOINT).then(response => response.json());
}

export function getExtract(id: number): Promise<ExtractInfo> {
	return get(`${ENDPOINT}/${id}`).then(response => response.json());
}

export function createExtract(request: GenerateExtractRequest): Promise<void> {
	return post(ENDPOINT, request).then(response => {
		if (response.status !== 202) {
			throw new Error(response.statusText);
		}
	});
}

export function deleteExtract(id: number): Promise<void> {
	return del(`${ENDPOINT}/${id}`).then(response => {
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}
	});
}

export function getExtractRights(id: number): Promise<string[]> {
	return get(`${ENDPOINT}/${id}/${USERS_SUFFIX}`).then(response =>
		response.json()
	);
}

export function updateExtractRights(
	id: number,
	users: string[]
): Promise<void> {
	return post(`${ENDPOINT}/${id}/${USERS_SUFFIX}`, users).then(response => {
		if (response.status !== 200) {
			throw new Error(response.statusText);
		}
	});
}

export function getExtractContent(id: number): Promise<Blob> {
	return get(`${ENDPOINT}/${id}/${CONTENT_SUFFIX}`).then(response =>
		response.blob()
	);
}
